import { useAuth } from "react-oidc-context";
import React from "react";
import Docs from './APIDocs/Docs';
import LoadingSpinner from "./components/LoadingSpinner";
import Homepage from "./pages/homepage";
import NotFound from "./pages/notfound";

function App() {
  const auth = useAuth();

  React.useEffect(() => {
    // the `return` is important - addAccessTokenExpiring() returns a cleanup function
    return auth.events.addAccessTokenExpiring(() => {
            auth.signinSilent();            
    })
}, [auth.events, auth.signinSilent])


  switch (auth.activeNavigator) {
    case "signinSilent":
      return <LoadingSpinner />;
    case "signoutRedirect":
      return <LoadingSpinner />;
  }

  if (auth.isLoading) {
    return <LoadingSpinner />;
  }

  if (auth.error) {
    return <NotFound message={auth.error.message} />;
  }

  if (auth.isAuthenticated) {
    return (
      <Docs token={auth.user?.access_token} />
    );
  }

  if (window.location.pathname.slice(1) != "") {
    auth.signinRedirect()
    return null;
  }

  return (
    <React.Fragment>
      <Homepage />
    </React.Fragment>
  );


}


export default App;
